import React from 'react';
import { WeaLocaleProvider } from 'ecCom';
import { Calendar } from 'antd';

const getLabel = WeaLocaleProvider.getLabel;
import Header from './Common/header';
import './css/index';

export default class Content_calendar extends React.Component {
    render() {
        const { data = {}, eid } = this.props;
        return (
            <div className="item" id={`item_${eid}`}>
                <Header ecId={`${this && this.props && this.props.ecId || ''}_Header@8n2g5f`} data={data} eid={eid} />
                <div className="content" id={`content_${eid}`}>
                    <div className="content_view" id={`content_view_id_${eid}`}>
                        <div className={`content_${eid}`}>
                            <div className={'element_prew_calendar'}>
                                <Calendar ecId={`${this && this.props && this.props.ecId || ''}_Calendar@aiucu7`} fullscreen={false} />
                                <div className="portal-element-calender-add">
                                    <i className="anticon anticon-plus-circle-o" title={getLabel(384113, '添加')} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/wea-element-preview/content/Content_calendar.js